import { Record } from 'immutable';

export interface CalendarSubscriptionInterface {
  subscriptionEmail: string | null;
  isBusy: boolean;
  subscriptionLookupFailed: boolean;
  unsubscribeFailed: boolean;
}

export const initialState: CalendarSubscriptionInterface = {
  subscriptionEmail: null,
  isBusy: false,
  subscriptionLookupFailed: false,
  unsubscribeFailed: false
};

export default class CalendarSubscriptionState extends Record(initialState) {}
